// Recommendation card variant selection (product-grouped swatches)
if (!customElements.get('recommendation-card')) {
  class RecommendationCard extends HTMLElement {
    connectedCallback() {
      // Parse current product variants
      const variantScript = this.querySelector('script.current-variants')
      if (variantScript) {
        try {
          this.variants = JSON.parse(variantScript.textContent)
        } catch (e) {
          this.variants = []
        }
      } else {
        this.variants = []
      }

      // Parse grouped variants (all sibling products keyed by handle)
      this.groupedVariants = {}
      const groupedScript = this.querySelector('script.grouped-variants')
      if (groupedScript) {
        try {
          this.groupedVariants = JSON.parse(groupedScript.textContent)
        } catch (e) {
          this.groupedVariants = {}
        }
      }

      this.sizeIndex = this.dataset.sizeIndex !== undefined ? parseInt(this.dataset.sizeIndex) : null
      this.selectedSize = null

      const sizeDropdown = this.querySelector('.rec-size-dropdown')
      if (sizeDropdown) this.selectedSize = sizeDropdown.value

      this.bindEvents()
    }

    bindEvents() {
      // Product-grouped swatch click — switches the entire card to a different product
      this.querySelectorAll('.rec-swatch').forEach(swatch => {
        swatch.addEventListener('click', () => this.handleSwatchClick(swatch))
      })

      const sizeDropdown = this.querySelector('.rec-size-dropdown')
      if (sizeDropdown) {
        sizeDropdown.addEventListener('change', () => {
          this.selectedSize = sizeDropdown.value
          this.updateVariantId()
        })
      }
    }

    handleSwatchClick(swatch) {
      // Update active state
      this.querySelectorAll('.rec-swatch').forEach(s => s.classList.remove('is-active'))
      swatch.classList.add('is-active')

      const handle = swatch.dataset.productHandle
      const newVariants = this.groupedVariants[handle]
      if (!newVariants) return

      // Update card data
      this.variants = newVariants
      this.dataset.productId = swatch.dataset.productId
      this.dataset.productUrl = swatch.dataset.productUrl
      this.dataset.productHandle = handle

      // Update image
      const img = this.querySelector('.product-image img')
      if (img && swatch.dataset.productImage) {
        const imgUrl = swatch.dataset.productImage
        img.src = imgUrl.replace('width=140', 'width=70')
        img.srcset = imgUrl.replace('width=140', 'width=70') + ' 1x, ' + imgUrl + ' 2x'
      }

      // Update title (group title stays same, but update link href)
      const titleEl = this.querySelector('a.product-title')
      if (titleEl) {
        if (swatch.dataset.productGroupTitle) {
          titleEl.textContent = swatch.dataset.productGroupTitle
        }
        titleEl.href = swatch.dataset.productUrl
      }

      // Update color name
      const colorNameEl = this.querySelector('.rec-variant-name')
      if (colorNameEl && swatch.dataset.productColorname) {
        colorNameEl.textContent = swatch.dataset.productColorname
      }

      const productTitleEl = this.querySelector('.rec-product-title')
      if (productTitleEl && swatch.dataset.productTitle) {
        productTitleEl.textContent = swatch.dataset.productTitle.split(' - ')[0].toLowerCase()
      }

      // Update price
      const priceEl = this.querySelector('.rec-price bdi')
      if (priceEl) priceEl.textContent = swatch.dataset.productPrice

      // Update image link href
      const imgLink = this.querySelector('.product-image a')
      if (imgLink) imgLink.href = swatch.dataset.productUrl

      // Rebuild size dropdown with new product's variants
      this.rebuildSizeDropdown()
    }

    rebuildSizeDropdown() {
      const sizeDropdown = this.querySelector('.rec-size-dropdown')
      if (!sizeDropdown || this.sizeIndex === null) return

      const sizes = []
      this.variants.forEach(v => {
        const size = v.options[this.sizeIndex]
        if (!sizes.find(s => s.value === size)) {
          sizes.push({ value: size, available: v.available })
        }
      })

      sizeDropdown.innerHTML = ''
      sizes.forEach(size => {
        const opt = document.createElement('option')
        opt.value = size.value
        opt.textContent = 'Size: ' + size.value + (size.available ? '' : ' - Sold Out')
        if (!size.available) opt.disabled = true
        sizeDropdown.appendChild(opt)
      })

      const firstAvailable = sizes.find(s => s.available)
      if (firstAvailable) {
        sizeDropdown.value = firstAvailable.value
        this.selectedSize = firstAvailable.value
      } else if (sizes.length) {
        this.selectedSize = sizes[0].value
      }

      this.updateVariantId()
    }

    updateVariantId() {
      const match = this.variants.find(v => {
        if (this.sizeIndex !== null && v.options[this.sizeIndex] !== this.selectedSize) return false
        return true
      })

      const addBtn = this.querySelector('add-to-cart')
      if (addBtn && match) {
        addBtn.dataset.variantId = match.id
        addBtn.classList.toggle('disabled', !match.available)
      }

      const priceEl = this.querySelector('.rec-price bdi')
      if (priceEl && match) priceEl.textContent = match.price
    }
  }
  customElements.define('recommendation-card', RecommendationCard)
}

// Quantity trash/minus icon toggle
function initQuantityIcons() {
  const trashSvg = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-remove" fill="none" viewBox="0 0 16 16"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/></svg>'
  const minusSvg = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"/></svg>'

  document.querySelectorAll('.mini-cart quantity-input').forEach(qi => {
    const input = qi.querySelector('.quantity__input')
    const minusBtn = qi.querySelector('[name="minus"]')
    if (!input || !minusBtn) return

    function updateIcon() {
      const val = parseInt(input.value)
      const iconEl = minusBtn.querySelector('.icon')
      if (!iconEl) return
      if (val <= 1) {
        iconEl.outerHTML = trashSvg
      } else {
        const currentIcon = minusBtn.querySelector('.icon')
        if (currentIcon && currentIcon.classList.contains('icon-remove')) {
          currentIcon.outerHTML = minusSvg
        }
      }
    }

    input.addEventListener('change', updateIcon)
    const plusBtn = qi.querySelector('[name="plus"]')
    if (plusBtn) plusBtn.addEventListener('click', () => setTimeout(updateIcon, 50))
    minusBtn.addEventListener('click', () => setTimeout(updateIcon, 50))
  })
}

// Run on initial load and after cart drawer updates
document.addEventListener('DOMContentLoaded', initQuantityIcons)
document.addEventListener('cartdrawer:opened', initQuantityIcons)
